<template>
  <v-dialog
    v-model="show"
    :fullscreen="$vuetify.breakpoint.mobile"
    scrollable
    :max-width="800"
    persistent
  >
    <v-card tile class="fill-height" color="background">
      <v-system-bar
        color="#FFFFFF"
        fixed
        v-if="platform == 'ios'"
        height="33"
        app
        class="pa-0"
      >
      </v-system-bar>
      <v-card-title
        class="pa-0 ma-0 font-weight-regular"
        :class="{ 'pt-8': platform == 'ios' }"
      >
        <listings
          v-if="!showHubs"
          :type="searchType" :hide-select="true"
          ref="listings"
          :manual="manual"
          prepend-icon="arrow_back"
          show :height="72"
          :autofocus="manual"
          :placeholder="hideHubs ? 'Zoek je adres' : 'Zoek een eetplein of je adres'"
          v-model="newAddress"
          :dark="dark"
          @search="setSearch"
          @result="setResult"
          @select="addAddress"
          @close="showAddAddress = false"
          @cancel="newAddress = null"
        >
          <v-btn slot="icon" class="float-left" icon @click.stop="reset()" v-if="listings.length> 0 || search"
            ><v-icon>arrow_back</v-icon></v-btn
          >
          <v-btn v-else slot="icon" class="float-left
          " icon @click.stop="close()"
            ><v-icon>arrow_back</v-icon></v-btn
          >
        </listings>

        <v-toolbar
          class="px-0"
          flat :height="77"
          v-else-if="popup && parent"
          fixed
        >
          <v-btn icon @click.stop="parent = null"
            ><v-icon>arrow_back</v-icon></v-btn
          >
          <v-toolbar-title class="px-0 font-weight-light"
            >{{ parent.name }}
          </v-toolbar-title>
        </v-toolbar>
        <v-toolbar
          class="px-0"
          flat  :height="77"
          v-else-if="popup"
          fixed
          :class="{ 'pl-3': tab == 0 && (hideHubs || largeScreen) }"
        >
          <v-btn
            icon
            @click.stop="showHubs=false"
            v-if="(!largeScreen && !hideHubs) || tab > 0"
            ><v-icon>arrow_back</v-icon></v-btn
          >
          <v-toolbar-title class="px-0 font-weight-light"
            >{{ title }}
          </v-toolbar-title>
          <v-spacer></v-spacer
          ><v-btn v-if="hideHubs || largeScreen" icon @click.stop="showHubs=false"
            ><v-icon>close</v-icon></v-btn
          >
        </v-toolbar>
      </v-card-title>
      <v-card-subtitle v-if="text" v-html="text"></v-card-subtitle>
       <v-progress-linear v-if="loading"
                    indeterminate
                    color="primary" striped
                  ></v-progress-linear>
      <slot name="message">
        <v-alert type="warning" v-model="showMessage" dismissible>{{
          message
        }}</v-alert>
      </slot>

      <v-card-text id="scrollbody" class="pa-0 pb-10" style="height: 50vh">
          <!--v-subheader v-if="errorMessage">{{errorMessage}}</v-subheader-->
      <v-expand-transition v-if="search || showHubs">
       <div v-if="hubList && hubList.length>0" class="mt-5">
       <hub-card
              v-for="(hub, i) in hubList"
              :key="'t' + hub._id + i"
              class="mx-3 mb-5"
              :value="hub"
              flat
              outlined
              @select="showHub"
            ></hub-card>
       </div>
       </v-expand-transition>

<v-subheader v-if="search && search.length>3 && listings.length==0">Nog geen adressen gevonden...</v-subheader>
      <v-expand-transition>
      <div v-if="!showHubs">
            <v-list v-if="listings.length>0" class="py-0">
                    <template  v-for="(item, index) in listings">
                     <address-item 
                        :key="index"
                        :value="item"
                       :hide-icon="true"
                        @valid="$refs.listings.select"
                        @select="$refs.listings.selectAddress"
                      > 
                      </address-item>
                      <v-divider :key="'t' + index"></v-divider>
                    </template>
                  </v-list>
            
        
         <v-expand-transition>
           <v-list class="py-0" v-if="addresses.length > 0">
            <v-divider v-if="(search && hubList.length>0)"></v-divider>
            <v-list-item-group
              v-model="addresitem"
              active-class="primary--text"
            >
              <template v-for="(addr, ii) in addresses">
                <v-list-item
                  @click="selectAddress(addr)"
                  :key="ii"
                  :value="addr.name"
                  :disabled="!addr.allow && (host ? true: false)"
                >
                  <v-list-item-icon class="mr-3"
                    ><v-icon v-if="addr.current" color="primary"
                      >location_on</v-icon
                    >
                    <v-icon v-else-if="!addr.allow" color="grey">close</v-icon>
                    <v-icon v-else-if="addresitem == addr.name" color="primary"
                      >check</v-icon
                    >
                    <v-icon v-else>home</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title
                      :class="{
                        'grey--text': !addr.allow,
                        'primary--text': addresitem == addr.name,
                      }"
                      >{{ addr.name }}</v-list-item-title
                    >
                    <v-list-item-subtitle
                      v-if="host"
                      :class="{
                        'grey--text': !addr.allow,
                        'primary--text': addresitem == addr.name,
                      }"
                      >{{ addr.distance }} km
                      <span v-if="amount < addr.min">
                        - Minimmaal bestelbedrag:
                        {{ addr.min | toCurrency }}</span
                      >
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action
                    :class="{
                      'grey--text': !addr.allow,
                      'primary--text font-weight-bold': addresitem == addr.name,
                    }"
                    v-if="host && addr.allow && amount < addr.max"
                  >
                    {{ addr.price | toCurrency }}
                  </v-list-item-action>
                  <v-list-item-action
                    :class="{
                      'grey--text': !addr.allow,
                      'primary--text font-weight-bold': addresitem == addr.name,
                    }"
                    v-else-if="
                      host && addr.allow && (addr.price == 0 || amount > 0)
                    "
                  >
                    gratis
                  </v-list-item-action>
                  <v-list-item-action v-else-if="host"> - </v-list-item-action>
                  <v-list-item-icon
                    @click.stop="deleteAddress(addr)"
                    :class="{
                      'grey--text': !addr.allow,
                      'primary--text font-weight-bold': addresitem == addr.name,
                    }"
                    ><v-icon small color="grey"
                      >delete</v-icon
                    ></v-list-item-icon
                  >
                </v-list-item>
                <v-divider :key="'d' + ii"></v-divider>
              </template>
            </v-list-item-group>
              </v-list>
          </v-expand-transition>
          <v-expand-transition>
          <div v-if="listings.length==0 && !search || message">
        <v-subheader class="mt-5" v-if="addresslist.length>0">Opties</v-subheader>
        <v-list class="py-0">
          <v-divider v-if="addresslist.length>0 || message"></v-divider>
          <v-list-item text primary small @click="getCurrentLocation()">
            <!--v-icon left>location_on</v-icon-->
            Gebruik mijn huidige locatie
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item v-if="searchType=='search'"
            text
            small
            @click="setSearchType('zipcode')"
          >
   
            Zoek op postcode en huisnummer
          </v-list-item>
          <!--v-divider></v-divider-->
          <v-list-item v-if="searchType=='zipcode'"
            text
            small
            @click="setSearchType('search')"
          >
            
            Voer je adres handmatig in
          </v-list-item>
          <v-divider></v-divider>
           <v-list-item text small @click="parent=null;search=null" v-if="!hideHubs && parent">
             <v-list-item-content>
            <v-list-item-title class="primary--text">{{parent.name}}</v-list-item-title>
           </v-list-item-content>
           <v-list-item-action>
             <v-btn @click="parent=null;search=null" icon><v-icon>close</v-icon></v-btn>
           </v-list-item-action>
          </v-list-item>
          
          <v-list-item text small @click="showHubs = !showHubs;parent=null;search=null" v-else-if="!hideHubs">
           
            <span v-if="showHubs">Eetpleinen verbergen</span><span v-else>Selecteer direct een eetplein(woonplaats)</span>
          </v-list-item>
          <!--v-list-item text small @click="showHubs = !showHubs;showAll=true;parent=null;search=null" v-else-if="!hideHubs">
           
            <span v-if="showHubs">Eetpleinen verbergen</span><span v-else>Alle eetpleinen weergeven</span>
          </v-list-item-->
          <v-divider v-if="!hideHubs"></v-divider>
        </v-list>
        </div>
        </v-expand-transition>
      </div>
       </v-expand-transition>
      </v-card-text>
      <v-card-actions class="white v-footer theme--light" v-if="this.$scopedSlots.buttons">
        <slot name="buttons" v-bind="{ close }"></slot>
      </v-card-actions>
      <v-bottom-navigation
        v-else-if="false"
        v-model="tab"
        color="primary"
        grow
        :height="platform == 'ios' ? 70 : 54"
      >
        <v-btn :class="{ 'pb-4': platform == 'ios' }">
          <span>Adres</span>

          <v-icon>mdi-map-marker</v-icon>
        </v-btn>

        <v-btn :class="{ 'pb-4': platform == 'ios' }">
          <span>Eetpleinen</span>

          <v-icon>mdi-apache-kafka</v-icon>
        </v-btn>
      </v-bottom-navigation>
    </v-card>
  </v-dialog>
</template>
<script>
import Listings from "../components/address/Listings.vue";
import AddressItem from "../components/address/AddressItem.vue";
import locationService from "@/modules/locationService";
import HubCard from "../components/HubCard.vue";
import empty from "../components/empty.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  mixins: [locationService],
  components: {
    Listings,
    HubCard,
    empty,
    AddressItem,
  },
  props: {
    value: {
      type: String,
      default: function () {
        return null;
      },
    },
    title: {
      type: String,
      default: function () {
        return "Selecteer een eetplein";
      },
    },
    text: {
      type: String,
      default: function () {
        return null;
      },
    },
    host: {
      type: Object,
      default: function () {
        return null;
      },
    },
    amount: {
      type: Number,
      default: function () {
        return 0;
      },
    },
    popup: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
    show: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
    showAdd: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
    outlined: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
    listHubs: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
    browse: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
    hideHubs: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
    color: {
      type: String,
      default: function () {
        return "transparent";
      },
    },
  },
  data: () => ({
    loading: false,
    tab: 0,
    newAddress: null,
    search: null,
    searchType: "search",
    manual: false,
    showSearch: false,
    showAddAddress: false,
    addresslist: [],
    parent: null,
    showHubs: false,
    showAll: false,
    list: [],
    listings: [],
    addresitem: null,
    message: null
    
  }),
  computed: {
    ...mapGetters(["user", "hub", "dark"]),
    selectedHub() {
      return this.hub;
    },
    pageHeight() {
      return document.body.scrollHeight;
    },
    hubList() {
    if (this.search) {
        return this.list.filter(
          (hub) =>
            (hub.name.toLowerCase().includes(this.search.toLowerCase()) &&
              (hub._subs.length == 0 || !this.parent)) ||
            (this.parent &&
              hub._parent &&
              hub._parent.name.toLowerCase().includes(this.search.toLowerCase()))
        );
      }
      /*if (this.regions.length > 0 && !this.showAll) {
        return this.list.filter(
          (hh) =>
            (this.hub && hh._id == this.hub._id) ||
            (hh._parent &&
              hh.region &&
              hh.region.filter &&
              hh.region.filter((region) => this.regions.includes(region))
                .length > 0)
        );
      }*/
      if (this.parent) return this.parent._subs
      //if (this.showAll) {
        return this.list.filter(
          (hub) => !hub._parent
        );
      //}
      return []
    },
    address: {
      get() {
        return this.$store.state.config.address || null;
      },
      set(value) {
        this.setConfig({ address: value });
      },
    },
    addresses(){
      if (this.search) return this.addresslist.filter(a=>
        a.name.toLowerCase().includes(this.search.toLowerCase()) 
        || a.zipcode.toLowerCase() == this.search.toLowerCase())
      return this.addresslist
    },
    showMessage: {
      get() {
        return this.message ? true : false
      },
      set(value) {
        this.message = null
      },
    },
    showCurrent() {
      if (!this.allowCurrent) return false;
      return this.addresslist.filter((a) => a.current).length == 0;
    },
    regions() {
      let regions = [];
      if (this.search) regions.push(this.search);
      /*this.addresslist.map(a=>{
        regions.push(a.city.toLowerCase())
        regions.push(a.zipcode.substring(0,4))
      })*/
      this.addresslist.map((address) => {
        regions.push(address.city.toLowerCase());
        regions.push(address.zipcode.substring(0, 4));
        regions.push("#" + address.zipcode.substring(0, 4));
      });
      return regions;
    },
  },
  async mounted() {
    this.reset()
    await this.load();
    if (this.showAdd) this.showAddAddress = true;
    this.searchType = (this.addresslist.length==0)  ? 'zipcode' : 'search'
  },
  watch: {
    tab() {
      this.showAll = false;
      this.parent = null;
      this.message = null;
    },
    address(value, old) {
      //this.selectAddress(value)
      if (value) this.addresitem = value.name;
    },
    showSearch(value) {
      if (!value) this.search = "";
    },
    show(value) {
      if (value) this.load();
    },
    regions(value) {
      //if (!value || value.length == 0) this.showAll = true;
    },
    search(value){
      if (!value) this.reset()
    }
  },
  methods: {
    ...mapActions(["setConfig", "setHub"]),
    setSearchType(value){
      this.manual = true
      this.searchType = value
    },
    async load() {
      this.addresslist = [];
      this.list = [];
      
      if (!this.host) {
        let response = await this.$http.post("/api/hub/list", {});
        this.list = response.data.sort((a, b) => (a.name < b.name ? -1 : 1));
      }
      if (this.$store.state.user && this.$store.state.user._address)
        this.$store.state.user._address.map((a) =>
          this.addresslist.push(this.calcAddress(a))
        );
      if (
        this.address &&
        this.address.name &&
        this.addresslist.filter((a) => a.name == this.address.name).length == 0
      )
        this.addresslist.unshift(this.calcAddress(this.address));
      this.addresslist.map((a) => (a.current = false));

      //if (this.browse) return this.showSearch = true
      this.showAddAddress = this.addresslist.length == 0;
      if (this.address) this.addresitem = this.address.name;
    },
    setSearch(search) {
      this.search = search;
    },
    setResult(list) {
      if (!list) return this.listings = []
      this.listings = list.filter(l=>l);
    },
    searchHubs(search) {
      if (search) {
        return this.list.filter(
          (hub) =>
            (hub.name.toLowerCase().includes(search.toLowerCase()) &&
              (hub._subs.length == 0 || !this.parent)) ||
            (this.parent &&
              hub._parent &&
              hub._parent.name.toLowerCase().includes(search.toLowerCase()))
        );
      }
      return [];
    },
    showHub(hub) {
      if (this.parent && this.parent._id == hub._id)
        return (this.parent = null);
      //this.$refs.listings.setSearch(hub.name);
      this.parent = hub
      if (hub._hosts && hub._hosts.length == 0) return (this.parent = hub);

      let res = this.addresslist.filter(
        (address) =>
          hub.region &&
          hub.region.filter(
            (region) =>
              region == address.city.toLowerCase() ||
              region == address.zipcode.substring(0, 4)
          ).length > 0
      );
      if (res[0]) this.address = res[0];
      this.setHub(hub);
      this.$nextTick(() => {
        this.close(true);
      });
    },
    selectAddress(address) {
      if (!address) return false;
      this.address = address;
      this.addresitem = address.name;
      this.showall = false;
      this.parent = null;
      if (address._hub) this.setHub(address._hub);
      this.$emit("select", this.address);
      this.close(true);
    },
    setAddAddress() {
      this.showAddAddress = true;
      setTimeout(() => {
        var objDiv = document.getElementById("scrollbody");
        objDiv.scrollTop = objDiv.scrollHeight;
      }, 300);
    },
    reset(){
      this.showAll = false;
      this.parent = null;
      this.message = null;
      this.listings = []
      if (this.$refs.listings) this.$refs.listings.resetMe()
      //this.address=null
      this.search = null
      this.newAddress = null;
    },
    close(force) {
      if (!force && this.tab == 1) return (this.tab = 0);
      this.reset()
      this.$emit("close", this.address);
    },
    select(aa) {
      this.address = aa
      this.$emit("select", this.address);
    },
    calcAddress(address) {
      address.allow = true;
      if (this.host) {
        let aa = this.setAddress(
          this.host.regions || [],
          this.host._address || {},
          address
        );
        address.allow = aa.allow; //!this.address ||
        address.distance = aa.distance;
        address.price = aa.price;
        address.amount = aa.price;
        address.min = aa.min;
        address.max = aa.max;
        if (address.price < 0) address.allow = false;
      } else {
        let hub = this.list.filter(
          (hub) =>
            hub._parent &&
            hub.region &&
            Array.isArray(hub.region) &&
            hub.region.includes(address.zipcode.substring(0, 4))
        )[0];
        address._hub = hub;
        address.allow = hub ? true : false;
      }
      return address;
    },
    async getCurrentLocation(select) {
      this.loading = true
      this.searchType = 'search'
      let address = await this.getLocation();
      if (!address) return false;
      address.current = true;
      if (select) return this.addAddress(address);
      this.newAddress = address;
      this.showAddAddress = true;
      setTimeout(()=> this.loading = false,1000)
      

      //this.addAddress(address, true, true);
    },
    async addAddress(address, ignore, addOnly) {
     
      if (!address || !address.name) return null;
      
      if (this.addresslist.filter((a) => a.name == address.name).length > 0) {
        if (ignore) {
          this.address = this.addresslist.filter(
            (a) => a.name == address.name
          )[0];
          return this.select();
        }
        return (this.message = "Adres is al geregistreerd");
      }
      this.message = null;
      address = this.calcAddress(address);
      
      if (address.allow == false && this.host) {
        return this.message = "Op " + address.name + " wordt niet geleverd";
      } else if (address.allow == false) {
        return this.message =
          "Er zijn nog geen eetpleinen in de buurt van " +
          address.name +
          ". Selecteer een ander adres of kies direct een eetplein.";
      }
      this.searchType == 'search'
      /*if (this.address && this.address._id)
        await this.$http.delete("/api/edge/ADDRESS/" + this.user._id, {
          _id: this.address._id,
          date: new Date(),
        });*/
      let aa = this.clone(address);
      delete aa.current;
      aa._key = (
        aa.zipcode.replace(/ /g, "") +
        aa.number +
        (aa.addition ? aa.addition : "")
      ).replace(/ /g, "");
      if (this.user)
        await this.$http.post("/api/edge/ADDRESS/" + this.user._id, aa);

      this.addresslist.push(address);
      this.reset()
      if (address.allow || !this.host) {
        if (!this.host && address._hub) this.setHub(address._hub)
        this.address = address;
        this.$emit("update", address);
        this.$nextTick(()=>{
            this.$emit("close", address);
        },2000)
        
      }

      //
    },
    async deleteAddress(address) {
      this.addresslist = this.addresslist.filter(
        (a) => a.name !== address.name
      );
      if (address._id)
        await this.$http.delete("/api/edge/ADDRESS/" + this.user._id, {
          _id: address._id,
          date: new Date(),
        });
      if (this.address && this.address.name == address.name)
        this.address = this.addresslist[0];
      if (this.addresslist.length == 0) this.showAddAddress = true;
      this.$emit("update");
    },
  },
};
</script>